/**
 * Created by coolguy on 2017/7/6.
 */
import {Api, Image} from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = Api('Image');
const IMAGE_SIGN = "IMAGE_SIGN";
const IMAGE_ADD = "IMAGE_ADD";
const IMAGE_REPLACE = "IMAGE_REPLACE";
const IMAGE_EXIST = "IMAGE_EXIST";
const IMAGE_REMOVE = "IMAGE_REMOVE";
const IMAGE_REMOVE_BATCH = "IMAGE_REMOVE_BATCH";
const IMAGE_EDIT = "IMAGE_EDIT";
const IMAGE_WATERMARK_BATCH = "IMAGE_WATERMARK_BATCH";
const IMAGE_CHECK_BATCH = "IMAGE_CHECK_BATCH";
const IMAGE_TRASH_BATCH = "IMAGE_TRASH_BATCH";
const IMAGE_BATCH_MOVE = "IMAGE_BATCH_MOVE";
const IMAGE_DOWNLOAD_BATCH = "IMAGE_DOWNLOAD_BATCH";
const IMAGE_DOWNLOAD_CLEAR = "IMAGE_DOWNLOAD_CLEAR";
const IMAGE_MOVE_BATCH = "IMAGE_MOVE_BATCH";
const IMAGE_LIST = "IMAGE_LIST";
const IMAGE_BATCH_TAG = "IMAGE_BATCH_TAG";
const IMAGE_OCR = "IMAGE_OCR";
const IMAGE_OCR_UPDATE = "IMAGE_OCR_UPDATE";
const IMAGE_FACE = "IMAGE_FACE";
const IMAGE_FACE_DELETE = "IMAGE_FACE_DELETE";
const IMAGE_COPY = "IMAGE_COPY";
const IMAGE_BEAUTY_CHANGE = "IMAGE_BEAUTY_CHANGE";

export default {
    IMAGE_SIGN,
    imageSign:()=> {
        return ajaxCommon({
            api: Image.sign,
            success: (data) => ({
                type: IMAGE_SIGN,
                data
            })
        })
    },
    IMAGE_ADD,
    imageAdd:(body, query)=>{
        query = query || {};
        //  这个返回有点坑, 主要原因是返回的id居然是string
        let addApi = TheApi('post')(`?useThin=${query.useThin?1:''}&useFilter=${query.useFilter?1:''}`);
        return ajaxCommon({
            api: addApi,
            data:body,
            success:(data)=>({
                type: IMAGE_ADD,
                data
            })
        })
    },
    IMAGE_COPY,
    imageCopy:(body)=>{
        return ajaxCommon({
            api: TheApi('post')('copy'),
            data:body,
            success:(data)=>({
                type: IMAGE_ADD,
                data
            })
        })
    },
    IMAGE_REMOVE,
    imageRemove:(imageId)=>{
        return ajaxCommon({
            api:TheApi('delete')(imageId),
            success:(data)=>({
                type:IMAGE_REMOVE,
                imageId,
                data
            })
        })
    },
    IMAGE_WATERMARK_BATCH,
    imageWatermarkBatch:(ids, data)=>{
      if(ids && ids.length && typeof data == 'number') {
        return ajaxCommon({
          api:TheApi('post')('watermark_batch'),
          data:{
            ids,
            target:data
          },
          success:(data)=>({
            type:IMAGE_WATERMARK_BATCH,
            ids,
            data
          })
        })
      }
      return {
        type:IMAGE_WATERMARK_BATCH
      }
    },
    IMAGE_CHECK_BATCH,
    imageCheckBatch:(ids, data, gallery_id)=>{
      if(ids && ids.length && typeof data == 'number') {
        return ajaxCommon({
          api:TheApi(`post`)(`check_batch`),
          data:{
            ids,
            target:data,
            gallery_id
          },
          success:(data)=>({
            type:IMAGE_CHECK_BATCH,
            ids,
            data
          })
        })
      }
    },
    IMAGE_TRASH_BATCH,
    imageTrashBatch:(ids, data, gallery_id)=>{
      if(ids && ids.length && typeof data == 'number') {
        return ajaxCommon({
          api:TheApi(`post`)(`trash_batch`),
          data:{
            ids,
            target:data,
            gallery_id
          },
          success:(data)=>({
            type:IMAGE_TRASH_BATCH,
            ids,
            data
          })
        })
      }
    },
    IMAGE_REMOVE_BATCH,
    imageRemoveBatch:(ids, gallery_id)=>{
      if(ids && ids.length) {
        return ajaxCommon({
            api:TheApi('post')('delete_batch'),
            data:{
                ids,
                gallery_id:gallery_id
            },
            success:(data)=>({
                type:IMAGE_REMOVE_BATCH,
                ids,
                data
            })
        })
      }
      return {
        type:IMAGE_REMOVE_BATCH
      };
    },
    IMAGE_EDIT,
    imageEdit: (imageid,info)=>{
        return ajaxCommon({
            api:TheApi('put')(imageid),
            data:info,
            success: (data)=>({
                type:IMAGE_EDIT,
                data
            })
        })
    },
    IMAGE_BEAUTY_CHANGE,
    imageBeautyChange: (imageid, beauty)=>{
        return ajaxCommon({
            api:TheApi('post')(`beauty_change`),
            data:{
                id:imageid,
                beauty
            },
            success: (data)=>({
                type:IMAGE_BEAUTY_CHANGE,
                data
            })
        })
    },
    IMAGE_BATCH_TAG,
    imageBatchTag:(ids, tag)=>{
        return ajaxCommon({
            api:TheApi('post')('tag_batch'),
            data:{
                ids:ids.join(','),
                tag
            },
            success:(data)=>({
                type:IMAGE_BATCH_TAG,
                data
            })
        })
    },
    IMAGE_BATCH_MOVE,
    imageBatchMove:(info)=>{
        return ajaxCommon({
            api:TheApi('post')('sort_batch'),
            data:info,
            success:(data)=>({
                type:IMAGE_BATCH_MOVE,
                data,
            })
        })
    },
    IMAGE_REPLACE,
    imageReplace: (info, query)=>{
        query = query || {};
        return ajaxCommon({
            api:TheApi('post')(`replace?useThin=${query.useThin?1:''}&useFilter=${query.useFilter?1:''}`),
            data:info,
            success:(data)=>({
                type:IMAGE_REPLACE,
                data
            })
        })
    },
    //批量下载图片
    IMAGE_DOWNLOAD_BATCH,
    imageDownloadBatch:(info)=>{
        return ajaxCommon({
            api:TheApi('post')('download_batch'),
            data:info,
            success:(data)=>({
                type:IMAGE_DOWNLOAD_BATCH,
                data,
            })
        })
    },
    IMAGE_DOWNLOAD_CLEAR,
    imageDownloadClear:(info)=>{
        return ajaxCommon({
            api:TheApi('post')('download_clear'),
            data:info,
            success:(data)=>({
                type:IMAGE_DOWNLOAD_CLEAR,
                data,
            })
        })
    },
    IMAGE_MOVE_BATCH,
    imageMoveBatch:(opt)=>{
        return ajaxCommon({
            api:TheApi('post')('move_batch'),
            data:opt,
            success:(data)=>({
                type:IMAGE_MOVE_BATCH,
                data,
            })
        })
    },
    IMAGE_EXIST,
    imageExist:(opt)=>{
        return ajaxCommon({
            api:TheApi('get')('one'),
            data:opt,
            success:(data)=>({
                type:IMAGE_EXIST,
                data,
            })
        })
    },
    IMAGE_LIST,
    imageList:(opt)=>{
        return ajaxCommon({
            api:TheApi('get')(),
            data:opt,
            success:(data)=>({
                type:IMAGE_EXIST,
                data,
            })
        })
    },
    IMAGE_OCR,
    imageOCR:(id)=>{
      return ajaxCommon({
        api:{
          url:'/api/image/ocr',
          method:'get'
        },
        data:{
          imageid:id
        },
        success:(data)=>({
          type:IMAGE_OCR,
          data
        })
      })
    },
    IMAGE_OCR_UPDATE,
    imageOCRUpdate:(imageid, words)=>{
      return ajaxCommon({
        api:{
          url:'/api/image/ocrupdate',
          method:'post'
        },
        data:{
          imageid,
          words
        },
        success:(data)=>({
          type:IMAGE_OCR_UPDATE,
          data
        })
      })
    },
    IMAGE_FACE,
    imageFace:(imageid)=>{
      return ajaxCommon({
        api:{
          url:'/api/image/face',
          method:'get'
        },
        data:{
          imageid
        },
        success:(data)=>({
          type:IMAGE_FACE,
          data
        })
      })
    },
    IMAGE_FACE_DELETE,
    imageFaceDelete:(face)=>{
      return ajaxCommon({
        api:{
          url:"/api/image/facedelete",
          method:'post'
        },
        data:face,
        success:(data)=>({
          type:IMAGE_FACE_DELETE,
          data
        })
      })
    }
}



// WEBPACK FOOTER //
// ./src/actions/ImageAction.js